import PropTypes from 'prop-types';
import Background from '../Background/Background';
import useStyles from './Banner.styles';

export default function Banner(props) {
  const classes = useStyles(props);
  
  return (
    <div className={classes.banner} data-test={`Banner__${props.componentName}`}>
      <Background componentName={props.componentName} />
      {props.children}
    </div>
  );
}

Banner.propTypes = {
  componentName: PropTypes.string,
  banner: PropTypes.string,
  children: PropTypes.node,
};
